import React, { useRef } from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import emailjs from "@emailjs/browser";

const ContactUs: React.FC = () => {
  const form = useRef<HTMLFormElement>(null);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.current) return;

    emailjs
      .sendForm(
        "diasys mongolia",  // Your EmailJS Service ID
        "template_kkhh6bq",  // Your EmailJS Template ID (contact us template)
        form.current,
        {
          publicKey: "kdNP9uzUlzv7zraqm",  // Your EmailJS Public Key
        }
      )
      .then(
        () => {
          console.log("SUCCESS!");
          // Optionally reset the form after successful submission
          form.current?.reset();
          alert("Message sent successfully!");
        },
        (error) => {
          console.log("FAILED...", error.text);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <>
     <div className="Compass">
        <p>/Contact Information/</p>
      </div><div className="contact-page">
      
      
      {/* Header */}
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p className="header-description">
          Thank you for your interest in DaiSys Mongolia. We value your feedback, questions, and inquiries.
        </p>
      </div>

      <div className="contact-grid">
        {/* Contact Information */}
        <div className="contact-info-section">
          <div>
            <h2 className="section-title">Contact Information</h2>
            <div className="info-items">
              <div className="info-item">
                <Mail className="info-icon" />
                <div>
                  <h3>General Inquiries</h3>
                  <p>support@dsm.mn</p>
                </div>
              </div>

              <div className="info-item">
                <Mail className="info-icon" />
                <div>
                  <h3>Sales and Partnerships</h3>
                  <p>sales@dsm.mn</p>
                </div>
              </div>

              <div className="info-item">
                <Phone className="info-icon" />
                <div>
                  <h3>Customer Support</h3>
                  <p>+976 9904 2483 </p>
                </div>
              </div>

              <div className="info-item">
                <MapPin className="info-icon" />
                <div>
                  <h3>Office</h3>
                  <p>
                    105, Baigal Khishig Ordon<br/>
                    Bayangol District, 16-r khoroo<br />
                    Ulaanbaatar 16040, MONGOLIA<br />
                    
                  </p>
                </div>
              </div>

              <div className="info-item">
                <Clock className="info-icon" />
                <div>
                  <h3>Business Hours</h3>
                  <p>Monday - Friday: 9:00 AM - 5:00 PM</p>
                  <p>Saturday: Closed</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info Card */}
          <div className="contact-card">
            <div className="card-header">
              <h3 className="card-title">Need Immediate Help?</h3>
              <p className="card-description">
                For urgent matters, please call our support line.
              </p>
            </div>
            <div className="card-content">
              <div className="card-buttons">
                <button className="card-button" type="button">
                  <Phone className="button-icon" />
                  Call Support: +976 9904 2483 -HELP
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form - FIXED VERSION */}
        <div className="contact-card">
          <div className="card-header">
            <h3 className="card-title">Send us a Message</h3>
            <p className="card-description">Fill out the form below and we'll get back to you.</p>
          </div>
          <div className="card-content">
            <form ref={form} onSubmit={sendEmail} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First Name *</label>
                  <input 
                    id="firstName" 
                    name="firstName" 
                    placeholder="John" 
                    required 
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name *</label>
                  <input 
                    id="lastName" 
                    name="lastName" 
                    placeholder="Doe" 
                    required 
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input 
                  id="email" 
                  name="email"
                  type="email" 
                  placeholder="john@example.com" 
                  required 
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input 
                  id="phone" 
                  name="phone"
                  type="tel" 
                  placeholder="+976 (123) 456-789" 
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input 
                  id="subject" 
                  name="subject"
                  placeholder="How can we help you?" 
                  required 
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Tell us more about your inquiry..."
                  className="message-input"
                  required
                  rows={5}
                />
              </div>

              <div className="form-checkbox">
                <input
                  type="checkbox"
                  id="newsletter"
                  name="newsletter"
                />
                <label htmlFor="newsletter">
                  I'd like to receive updates and newsletters
                </label>
              </div>

              <button type="submit" className="submit-button">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="map-section">
        <div className="contact-card">
          <div className="card-header">
            <h3 className="card-title">Find Us</h3>
            <p className="card-description">Visit our office or use the map below to get directions.</p>
          </div>
          <div className="card-content">
            <div className="map-container">
              <a 
                href="https://maps.app.goo.gl/MCYJDexa6bv2x9pJA" 
                className="map-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img 
                  src="map.jpg" 
                  alt="DaiSys Mongolia Location" 
                  className="map-image" 
                />
              </a>
              <p className="map-address">
                S105, Baigal Ordon, Bayangol Dist-16, Ulaanbaatar, Mongolia
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Social Media */}
      <div className="social-section">
        <h2 className="section-title">Connect with Us</h2>
        <p className="social-description">
          Follow us on social media to stay updated with our latest news and updates:
        </p>
        <div className="social-links">
          <a 
            href="https://www.facebook.com/diasysmongolia" 
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook 
            <p>ⓕ</p>
          </a>
          <a 
            href="https://www.youtube.com/@DiaSysMongoliaLLCDiaSys-u8o" 
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Youtube
            <p>[ ▶︎ ] </p>
          </a>
        </div>
      </div>
    </div>
     
    </>
  );
};

export default ContactUs;